import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-facebook",
  "use": "icon-facebook-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"icon-facebook\"><path d=\"M24 0H1C.5 0 0 .5 0 1v23c0 .6.5 1 1 1h12.2v-9.4h-3.1v-3.9h3.1V8.6c0-3.2 2-4.8 4.9-4.8 1.4 0 2.6.1 2.9.1v3.4h-2c-1.6 0-1.9.7-1.9 1.8v2.6H21l-.8 3.9h-3.1l.1 9.4H24c.6 0 1-.5 1-1V1c0-.5-.5-1-1-1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol